import React, { FormEvent } from 'react';
import { Checkbox as BSCheckBox } from 'react-bootstrap';
import { useDirtyWarningContext, DirtyWarningInputProps } from '../DirtyWarning';

type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>

interface ModifiedCheckboxProps extends Omit<BSCheckBox.CheckboxProps, "onChange">{}

export interface CheckboxProps extends ModifiedCheckboxProps, DirtyWarningInputProps {
   onChange?: (event: any, data?: any) => void;
   cbData?: any;
}

export const Checkbox: React.FC<CheckboxProps> = (props) => {
   const {onChange, disableDirtyTracking = false, ...otherProps} = props;
   const context = useDirtyWarningContext();

   const handleChange = function(e: any){
      if (onChange){
           onChange(e, props.cbData || {});
      }

      if (!disableDirtyTracking) {
         context.setDirty(true);
      }
  };

      return (
         <BSCheckBox {...otherProps} onChange={handleChange}>
            {props.children}
         </BSCheckBox>
      )
   }

(Checkbox as any).displayName = 'Checkbox';